export default __webpack_public_path__ + "CircularCustCapNum-Bold.e8b3d347cefa6ea8170391fcb4a6082f.ttf";